import BaseEntity from '@/entity/BaseEntity';
import OrderEntity from '../order/OrderEntity';

export default class TempWorkerCandidateEntity extends BaseEntity<IUserForOrderClientProposalDetailsModel> {
	get firstName () { return this.state.firstName; }
	get lastName () { return this.state.lastName; }
	get avatarId () { return this.state.avatarId; }
	get personalInformationPostCode () { return this.state.personalInformationPostCode; }
	get personalInformationCity () { return this.state.personalInformationCity; }
	get introduction () { return this.state.tempWorkerInformationIntroduction; }
	get professionalSkills () { return this.state.professionalSkills; }
	get userLanguages () { return this.state.userLanguages; }
	get professionalExperiences () { return this.state.professionalExperiences; }
	get userProfileComments () { return this.state.userProfileComments; }
	get profileIsPublic () { return this.state.profileIsPublic; }

	get name () {
		return [
			this.state.firstName,
			this.state.lastName,
		].filter(x => !!x?.length).join(' ');
	}

	get namePartial () {
		return [
			this.state.firstName,
			this.state.lastName ? `${this.state.lastName[0]}.` : undefined,
		].filter(x => !!x?.length).join(' ');
	}

	get orderedProfessionalExperiences () {
		return this.professionalExperiences.sort((a, b) => new Date(b.startDate).valueOf() - new Date(a.startDate).valueOf());
	}


	hasRequiredOrderProfessionalSkill (order: OrderEntity) {
		return !!this.professionalSkills.find(x => x.id === order.professionalSkill?.id);
	}

	isOrderProfessionalSkill (order: OrderEntity, skillId: number) {
		return skillId === order.professionalSkill?.id;
	}
}
